export default "__VITE_ASSET__rRIYWnCL__"